import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PAGES } from './page';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent {
  pages: any = PAGES;
  page: any;
  constructor(private readonly router: Router, private meta: Meta) {
    const article = this.router.url.replace(/-/gi, '_').substring(1);
    this.page = this.pages[article];
    this.meta.updateTag({
      name: 'robots',
      content: 'noindex',
    });
  }
}
